import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=4947bcb9&scoped=true"
import script from "./Train.vue?vue&type=script&lang=js"
export * from "./Train.vue?vue&type=script&lang=js"
import style0 from "./Train.vue?vue&type=style&index=0&id=4947bcb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4947bcb9",
  null
  
)

export default component.exports